const SEGMENTO_TOKEN = '[^/?#]+';
/** Mascara tokens presentes no caminho antes de enviar URLs ao console. */
export const sanitizeApiUrlForLog = (url) => String(url)
    .replace(new RegExp(`(/public/)${SEGMENTO_TOKEN}`, 'gi'), '$1[TOKEN]')
    .replace(new RegExp(`(/validar-link/)${SEGMENTO_TOKEN}`, 'gi'), '$1[TOKEN]');
